<template>
  <div class="usdt_wrap">
    <div class="red_top_bg">
      <div
        class="back_left"
        @click="$router.push('/user')"
      />
      <div class="big_tit">
        {{ $t('cash.withdraw') }}
      </div>
      <div
        class="top_right"
        @click="$router.push('/cashlist')"
      >
        <van-icon
          name="bars"
          size="18"
        />
      </div>
    </div>
    <div class="grid-wrap">
      <a
        class="grid-item"
        @click="$router.push('/cash')"
      >
        <div class="link-body"><h3 class="link-title">{{ $t('d.c2bank') }}</h3></div>
        <!-- <div class="link-foot">{{$t('income.jichud')}}</div> -->
      </a>
      <a
        class="grid-item"
        @click="$router.push('/cash2')"
      >
        <div class="link-body"><h3 class="link-title">{{ $t('d.c2usdt') }}</h3></div>
        <!-- <div class="link-foot">{{$t('income.tuid')}}</div> -->
      </a>
    </div>
  </div>
</template>

<script>
	import Vue from 'vue';
    import Fetch from '../../utils/fetch'
	import Api from "../../interface/index";
	import bsHeader from '../../components/bsHeader.vue'
	import Clipboard from 'v-clipboard';
	import {
		Icon
	} from 'vant';
	Vue.use(Clipboard).use(Icon);
    export default {
        name: "Pay",
        data() {
            return {
                data: null,
                money: 0,
            };
        },
        created() {
            this.$parent.footer('user', true);
        },
        mounted() {
        },
        methods: {
           
        }
    };
</script>

<style lang="less" scoped>
	.usdt_wrap {
		box-sizing: border-box;
		min-height: 100vh;
		padding-bottom: 1.2rem;
		background: url('../images/shop2/2.png') no-repeat top;
	}

	.red_top_bg {
		height: 50px;
		border-bottom: 1px solid rgba(235, 235, 235, .9);
		background: rgba(255, 255, 255, .88);
		box-shadow: none;
		color: #222;
		backdrop-filter: blur(10px);
	}

	.big_tit {
		top: 0;
		height: 50px;
		color: #222;
		font-size: 14px;
		font-weight: 700;
		line-height: 50px;
	}

	.back_left {
		position: relative;
		width: 44px;
		height: 50px;
		margin: 0;
		background: none;
	}

	.back_left::after {
		position: absolute;
		top: 18px;
		left: 17px;
		width: 11px;
		height: 11px;
		border-bottom: 2px solid #484848;
		border-left: 2px solid #484848;
		content: '';
		transform: rotate(45deg);
	}

	.top_right {
		top: 0;
		right: 0;
		box-sizing: border-box;
		display: flex;
		width: 44px;
		height: 50px;
		align-items: center;
		justify-content: center;
		color: #484848;
	}

	.grid-wrap {
		display: grid;
		gap: 14px;
		margin: 0;
		padding: 18px 16px 0;
	}

	.link-body {
		box-sizing: border-box;
		display: flex;
		min-height: 106px;
		align-items: flex-start;
		padding: 20px 18px;
		background: no-repeat center / cover;
	}
	.grid-item:first-child .link-body {
		color: #3b587b;
		background-image: url(../images/index/deposit.png);
	}
	
	.grid-item:last-child .link-body {
		color: #8b5049;
		background-image: url(../images/index/depositright.png);
	}
	
	.link-foot {
		padding: 15px;
		line-height: 18px;
		color: #6d6d6d;
	}
	.link-title {
		max-width: 72%;
		margin: 0;
		font-size: 14px;
		font-weight: 700;
		line-height: 1.45;
	}
	
	.grid-item {
		overflow: hidden;
		display: block;
		position: relative;
		margin: 0;
		border: 1px solid rgba(255, 255, 255, .85);
		border-radius: 18px;
		background: #fff;
		box-shadow: 0 8px 20px rgba(50, 40, 48, .06);
		text-decoration: none;
		transition: transform .2s ease, box-shadow .2s ease;

		&:active {
			transform: scale(.985);
			box-shadow: none;
		}
	}
</style>
